import PropTypes from 'prop-types';
import {Icon, Grid, Popup} from 'semantic-ui-react';

import {buildAdminGroupUrl, buildUserUrl} from 'components/Common/sharedElements';
import SiteManagementLink from 'components/Common/SiteManagementLink';
import {getTypeLabel} from 'components/Common/siteTypesLabels';

import styles from './SearchResult.module.scss';

const SearchResult = ({site, highlight}) => {
  return (
    <Grid
      columns={7}
      className={styles.SearchResult}
      textAlign="center"
      verticalAlign="middle"
      stackable
    >
      <Grid.Row>
        <Grid.Column width={4} className={styles.TruncatedText}>
          <div>
            <a href={`https://${site.url}`} target="_blank" rel="noreferrer">
              {highlight(site.url)}
            </a>
          </div>
          <Popup
            trigger={
              <div className={`${styles.TruncatedText} ${styles.GreyText}`}>
                {site.description ? highlight(site.description) : <i>No description available</i>}
              </div>
            }
            position="bottom center"
          >
            {site.description}
          </Popup>
        </Grid.Column>
        <Grid.Column width={2}>{getTypeLabel(site.displayType)}</Grid.Column>
        <Grid.Column width={2} className={styles.Category}>
          {site.category}
        </Grid.Column>
        <Grid.Column width={2} className={styles.TruncatedText}>
          <Popup
            trigger={
              <div className={styles.TruncatedText}>
                <a href={buildUserUrl(site.owner)} target="_blank" rel="noreferrer">
                  {highlight(site.owner)}
                </a>
              </div>
            }
            position="bottom center"
          >
            {site.owner}
          </Popup>
        </Grid.Column>
        <Grid.Column width={2} className={styles.TruncatedText}>
          <Popup
            trigger={
              <div className={styles.TruncatedText}>
                {site.adminGroup ? (
                  // TODO: update link when Grappa finally takes over from e-groups (https://gitlab.cern.ch/webservices/webservices-portal/-/issues/198)
                  <a href={buildAdminGroupUrl(site.adminGroup)} target="_blank" rel="noreferrer">
                    {highlight(site.adminGroup)}
                  </a>
                ) : (
                  <i className={styles.GreyText}>No group</i>
                )}
              </div>
            }
            position="bottom center"
          >
            {site.adminGroup ? (
              // TODO: update link when Grappa finally takes over from e-groups (https://gitlab.cern.ch/webservices/webservices-portal/-/issues/198)
              <a href={buildAdminGroupUrl(site.adminGroup)} target="_blank" rel="noreferrer">
                {highlight(site.adminGroup)}
              </a>
            ) : (
              <i className={styles.GreyText}>No group</i>
            )}
          </Popup>
        </Grid.Column>
        <Grid.Column width={3}>
          <>
            <Popup
              trigger={
                <div className={styles.TruncatedText}>
                  <b>Project name: </b>
                  {highlight(site.projectName)}
                </div>
              }
              position="bottom center"
            >
              {site.projectName}
            </Popup>
            <Popup
              trigger={
                <div className={styles.TruncatedText}>
                  <Icon name="calendar alternate outline" />
                  <b>Created on: </b>
                  {site.creationTimestamp ? (
                    new Date(site.creationTimestamp).toLocaleString()
                  ) : (
                    <i className={styles.GreyText}>No date available</i>
                  )}
                </div>
              }
              position="bottom center"
            >
              {site.creationTimestamp ? (
                new Date(site.creationTimestamp).toLocaleString()
              ) : (
                <i className={styles.GreyText}>No date available</i>
              )}
            </Popup>
            <Popup
              trigger={
                <div className={styles.TruncatedText}>
                  <Icon name="home" />
                  <b>Hosting Environment: </b>
                  {site.environment}
                </div>
              }
              position="bottom center"
            >
              {site.environment}
            </Popup>
          </>
        </Grid.Column>
        <Grid.Column width={1} textAlign="center">
          <SiteManagementLink type={site.displayType} projectName={site.projectName} showIcon />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

SearchResult.propTypes = {
  site: PropTypes.object.isRequired,
  highlight: PropTypes.func.isRequired,
};

export default SearchResult;
